import { get } from 'lodash';
import { extractButton } from '../../utils/elements';
import { ButtonAlign } from '../../types';
export const getButton = ({ region, css, isRtl = false, experiments = {}, }) => {
    const buttonStyles = get(region, 'data.styles.button') || {};
    const defaultStyles = css['so-global-b1-mix'];
    const button = extractButton({
        customStyles: buttonStyles,
        defaultStyles,
        experiments,
        isRtl,
        region,
        defaultButtonAlignment: isRtl ? ButtonAlign.right : ButtonAlign.left,
    });
    return button;
};
//# sourceMappingURL=get-button.js.map